import { jsx as _jsx } from "react/jsx-runtime";
import { useLocationState, useParams } from '@rocketlane/rocket-router';
import { PageLoader } from '@rocketlane/ui';
import React, { Suspense, useMemo } from 'react';
import { useWithAccess } from 'hooks/rbac/useWithAccess';
import { useAccountDataQuery } from 'queries/account';
import { NotFound } from 'routes/404';
const DocumentAgentChat = /*#__PURE__*/ React.lazy(()=>import('signals/DocumentAgentChat'));
export const DocumentAgentChatPage = ()=>{
    const { documentationAgentId } = useParams();
    const locState = useLocationState();
    const agentId = documentationAgentId && /^\d+$/.test(documentationAgentId) ? Number(documentationAgentId) : NaN;
    if (!Number.isSafeInteger(agentId) || agentId <= 0) {
        return /*#__PURE__*/ _jsx(NotFound, {});
    }
    return /*#__PURE__*/ _jsx("div", {
        className: "w-full h-full",
        children: /*#__PURE__*/ _jsx(Suspense, {
            fallback: /*#__PURE__*/ _jsx(PageLoader, {}),
            children: /*#__PURE__*/ _jsx(DocumentAgentChat, {
                documentationAgentId: agentId,
                agentName: locState === null || locState === void 0 ? void 0 : locState.agentName
            })
        })
    });
};
export const DocumentAgentChatRouteGuard = ()=>{
    var _ref;
    var _accountData_accountMeta_features, _accountData_accountMeta;
    const { data: accountData, isLoading: isAccountLoading } = useAccountDataQuery();
    const { hasAccessToResource, isLoading: isAccessLoading } = useWithAccess();
    const isEnabled = (_ref = accountData === null || accountData === void 0 ? void 0 : (_accountData_accountMeta = accountData.accountMeta) === null || _accountData_accountMeta === void 0 ? void 0 : (_accountData_accountMeta_features = _accountData_accountMeta.features) === null || _accountData_accountMeta_features === void 0 ? void 0 : _accountData_accountMeta_features.documentationAgent) !== null && _ref !== void 0 ? _ref : false;
    const canInvoke = useMemo(()=>hasAccessToResource({
            rule: 'DOCUMENT_AGENT:CREATE'
        }), [
        hasAccessToResource
    ]);
    if (isAccountLoading || isAccessLoading) return /*#__PURE__*/ _jsx(PageLoader, {});
    if (!isEnabled || !canInvoke) return /*#__PURE__*/ _jsx(NotFound, {});
    return /*#__PURE__*/ _jsx(DocumentAgentChatPage, {});
};
